const values = [
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20warm%20textured%20surface%20with%20soft%20organic%20patterns%20and%20gentle%20light%20gradients%2C%20warm%20amber%20and%20cream%20tones%2C%20smooth%20flowing%20textures%20reminiscent%20of%20natural%20stone%20and%20sand%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20meditative%20minimalist%20aesthetic&width=800&height=800&seq=values-card-01&orientation=squarish",
    title: "Continuous Innovation",
    subtitle: "Evolving tools, exploring new technologies, improving workflows",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20dark%20textured%20surface%20with%20subtle%20geometric%20grid%20patterns%20and%20fine%20lines%2C%20charcoal%20and%20warm%20gray%20tones%2C%20precise%20clean%20composition%20with%20delicate%20linear%20details%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20precision%20engineering%20aesthetic&width=800&height=800&seq=values-card-02&orientation=squarish",
    title: "Technical Excellence",
    subtitle: "Adopting modern engineering standards for reliable solutions",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20warm%20minimal%20textured%20surface%20with%20soft%20layered%20shadows%20and%20diffused%20light%2C%20warm%20beige%20and%20terracotta%20undertones%2C%20smooth%20elegant%20composition%20with%20depth%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20timeless%20quality%20aesthetic&width=800&height=800&seq=values-card-03&orientation=squarish",
    title: "Long-Term Quality",
    subtitle: "Building for durability, maintainability, and future readiness",
  },
];

export default function CoreValues() {
  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-[1440px] mx-auto px-8 md:px-16">
        <h2 className="text-center text-4xl md:text-5xl font-normal text-foreground-950 font-heading mb-16 md:mb-20">
          What drives us
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {values.map((value) => (
            <div
              key={value.title}
              className="relative rounded-[22px] overflow-hidden aspect-square group"
            >
              <img
                src={value.image}
                alt={value.title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-black/10"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-8">
                <h3 className="text-2xl md:text-3xl font-bold text-white leading-tight mb-3">
                  {value.title}
                </h3>
                <p className="text-sm md:text-base text-white/80 leading-relaxed max-w-[260px]">
                  {value.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}